"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSourceClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class EventSourceClient extends BaseApiClient_1.BaseApiClient {
    async registerBinding(registerBinding) {
        const path = `/eventsource/`;
        return await this.request('put', path, undefined, registerBinding);
    }
}
exports.EventSourceClient = EventSourceClient;
